import { CloudUpload } from '@mui/icons-material';
import { Button, CircularProgress, InputProps } from '@mui/material';
import { darken, styled } from '@mui/system';

import theme from 'styles/theme/theme';

interface UploadButtonProps extends InputProps {
  children?: React.ReactNode;
  isLoading?: boolean;
  acceptedFiles?: string;
}

export const UploadButton = (props: UploadButtonProps) => {
  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  });

  const UButton = () => (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={
        props.isLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : <CloudUpload />
      }
      sx={{
        minWidth: '14em',
        backgroundColor: props.isLoading ? darken(theme('de').palette.primary.main, 0.1) : undefined
      }}
    >
      {props.children}
      <VisuallyHiddenInput
        type="file"
        accept={props.acceptedFiles}
        onChange={props.onChange}
        multiple
      />
    </Button>
  );

  return <UButton />;
};
